import { render, staticRenderFns } from "./charge-by-bill-form.vue?vue&type=template&id=3bf807c2&"
import script from "./charge-by-bill-form.vue?vue&type=script&lang=js&"
export * from "./charge-by-bill-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports